import { render, staticRenderFns } from "./SignInForm.vue?vue&type=template&id=caf50872&scoped=true"
import script from "./SignInForm.vue?vue&type=script&lang=ts"
export * from "./SignInForm.vue?vue&type=script&lang=ts"
import style0 from "./SignInForm.vue?vue&type=style&index=0&id=caf50872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf50872",
  null
  
)

export default component.exports